import { ref } from "vue";

const mode = ref('INFO');

export const debug = () => {
  return mode.value === 'DEBUG';
};

const debugMode = true; // 디버그 모드 여부 설정

function debugLog(...args) {
  if (debugMode) {
    console.log(...args);
  }
}

function debugError(...args) {
  if (debugMode) {
    console.error(...args);
  }
}

export { debugLog, debugError };